import React from 'react';
import { styled } from "../stitches.config"
import { h3 } from "./commonStyles/Fonts";
import { bodyLarge } from "./commonStyles/Fonts";

interface DashboardHeaderProps {
    title: string,
    description?: string,
    btnActive: boolean,
    btnText: string,
    onBtnClick?: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
    title,
    description,
    btnActive = false,
    btnText,
    onBtnClick,
    ...props
}) => {
    return (
        <StyledDashboardHeader>
            <StyledDashboardHeaderWrapper>
                <p className={h3()}>{title}</p>
                {btnActive ? (<button onClick={onBtnClick} className={bodyLarge()}>+ {btnText}</button>) : ("")}
            </StyledDashboardHeaderWrapper>
            {description && <Description className={bodyLarge()}>{description}</Description>}
        </StyledDashboardHeader>
    );
};


const StyledDashboardHeader = styled('div', {
    padding: "32px 0px 24px 0px",
    width: "100% !important",
    "@bp4": {
        padding: "24px 0px",
    },
    "& p": {
        margin: 0,
        color: "$grayscale100"
    }
})

const StyledDashboardHeaderWrapper = styled('div', {
    display: "flex",
    justifyContent: "space-between",
    "& button": {
        color: "$primary",
        background: "none",
        borderWidth: "0px",
        cursor: "pointer",
    }
})

const Description = styled('p', {
    margin: "8px 0 0 0 !important",
    width: "100%",
    color: "$grayscale75 !important",
})

export default DashboardHeader